import { EditAction } from '../shared/enum/EditAction';

export interface ContentModel {
    id: number,
    codeMetric: number | null,
    name: string,
    weight: number,
    startOfPeriod: Date,
    endOfPeriod: Date | null,
    editAction: EditAction
}

export const contentModelInitial: ContentModel = {
    id: 0,
    codeMetric: null,
    name: '',
    weight: 0,
    startOfPeriod: new Date(),
    endOfPeriod: null,
    editAction: EditAction.NONE
};